import axiosNewApi from "../config/axiosNewApi";

export const sendRequestForm = async (formData, requestFormItems) => {
  try {
    const payload = {
      values: {
        email: formData.email,
        name: formData.name,
        phone: formData.phone,
        case_nr: formData.orderNumber,
        message: formData.message,
        payload: requestFormItems.map((item) => ({
          type: item.type === "machine" ? "machine" : "filter",
          amount: item.quantity,
          name: item.type === "machine" ? item.name : null,
          ref: item.type === "machine" ? null : item.name,
        })),
        number: null,
        amount: requestFormItems.reduce((acc, item) => acc + item.quantity, 0),
      },
    };

    const response = await axiosNewApi.post(
      "mobile/orders/send-order-request",
      payload
    );

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Unexpected status code: ${response.status}`);
    }
  } catch (error) {
    console.error("Error sending request:", error);
    throw error;
  }
};
